import _ from 'lodash'

const MULTIMEDIA_DEMO_CONFIG = {
    section: _.select( '.c-section--business-multimedia-demo-popup' ),
    overlay: _.select( '.c-section--business-multimedia-demo-popup .popup__overlay' ),
    form: _.select( '.c-section--business-multimedia-demo-popup form' ),
    triggers: _.selectAll( '.multimedia-demo-trigger' ),
    endpoint: 'demo/request/'
}

export default MULTIMEDIA_DEMO_CONFIG